<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_882_86296" height="40" maskUnits="userSpaceOnUse" style="mask-type:alpha" width="40" x="0" y="0">
      <circle cx="20" cy="20" fill="#737373" r="19.0476" :stroke="fill" stroke-width="1.90476"/>
    </mask>
    <g mask="url(#mask0_882_86296)">
      <circle cx="20" cy="20" r="18.5" :stroke="fill" stroke-width="3"/>
      <path d="M27.9975 20C27.9975 25.4147 27.0078 30.2683 25.4498 33.7307C23.8493 37.2873 21.8451 38.9975 20 38.9975C18.1549 38.9975 16.1507 37.2873 14.5502 33.7307C12.9922 30.2683 12.0025 25.4147 12.0025 20C12.0025 14.5853 12.9922 9.73169 14.5502 6.26926C16.1507 2.71272 18.1549 1.00251 20 1.00251C21.8451 1.00251 23.8493 2.71272 25.4498 6.26926C27.0078 9.73169 27.9975 14.5853 27.9975 20Z" :stroke="fill" stroke-width="2.00501"/>
      <path d="M20 12C16.0079 12 12.4422 11.0271 9.90789 9.50647C7.35365 7.97392 6 5.99602 6 4C6 2.00398 7.35365 0.0260784 9.90789 -1.50647C12.4422 -3.02707 16.0079 -4 20 -4C23.9921 -4 27.5578 -3.02707 30.0921 -1.50647C32.6464 0.0260796 34 2.00398 34 4C34 5.99602 32.6464 7.97392 30.0921 9.50647C27.5578 11.0271 23.9921 12 20 12Z" :stroke="fill" stroke-width="2"/>
      <path d="M20 43.333C16.0079 43.333 12.4422 42.3601 9.90789 40.8395C7.35365 39.3069 6 37.329 6 35.333C6 33.337 7.35365 31.3591 9.90789 29.8265C12.4422 28.3059 16.0079 27.333 20 27.333C23.9921 27.333 27.5578 28.3059 30.0921 29.8265C32.6464 31.3591 34 33.337 34 35.333C34 37.329 32.6464 39.3069 30.0921 40.8395C27.5578 42.3601 23.9921 43.333 20 43.333Z" :stroke="fill" stroke-width="2"/>
      <rect :fill="fill" height="2" width="39" y="19"/>
      <rect height="2" :stroke="fill" width="39" y="19"/>
    </g>
  </svg>

</template>

<script>
export default {
  name: 'World',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
